import { Component, OnInit, Inject, ViewChildren, QueryList } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, DateAdapter, MatSnackBar, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { TechniciansService } from '../services/technicians.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ModalsComponent } from '../modals/modals.component';
import { ActionsService } from '../services/actions.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MachineService } from '../services/machine.service';
import { Location } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';



export interface Technician {
  id: number;
  name: string;
  phone: string;
  unique_number: string;
}

export interface TechnicianRequest {
  name: string;
  unique_number: string;
  status: any;
  time_taken: any;
  taken_at: any;
  finished_at: any;
  reference_number: string;
  indicatorName: any;
}

export interface BusyTechnician {
  name: string;
  time_taken: any;
  doneIndicators: any;
  takenIndicators:any;
  allIndicators: any;
}


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-technicians',
  templateUrl: './technicians.component.html',
  styleUrls: ['./technicians.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class TechniciansComponent implements OnInit {
  technicians: any;
  add: boolean;
  edit: boolean;
  delete: boolean;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  technicianNames: any = [];
  //filter
  filter: number;
  nameOrNumber: string;
  requestNumber: string;
  machines: any;
  //technicianRequest
  technicianRequest: any;
  requestColumnsToDisplay: any;
  requestDisplayedColumns: any;
  requestDataSource: any;
  requestSelection: any;
  //technicianRequestFilter
  reference_number: any;
  fromDate: any;
  toDate: any;
  technician: string;
  status: string;
  //busyTechnician
  busyTechnician: any;
  busyColumnsToDisplay: any;
  busyDisplayedColumns: any;
  busyDataSource: any;
  busySelection: any;
  token:string = localStorage.getItem('token');


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(private technicianService: TechniciansService,
    private machineService: MachineService,
    private dialog: MatDialog,
    private actionService: ActionsService,
    private _location:Location,
    private dateAdapter: DateAdapter<Date>) {
    this.getTechnicians();
    this.technicianRequests();
    this.busyTechnicians();
    this.getMachines();
    this.getTechniciansNames();
    this.getActions();
    dateAdapter.setLocale('en-GB');

  }

  ngOnInit() {

  }





  getTechnicians() {
    this.technicianService.getTechnicians().subscribe(data => {
      this.technicians = data;
      this.displayedColumns = ['unique_number', 'name', 'email', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Technician>(this.technicians);
      this.selection = new SelectionModel<Technician>(true, []);
      this.dataSource.sort = this.sort.toArray()[0];
      this.dataSource.paginator = this.paginator.toArray()[0];
    });
  }

  //2nd select
  technicianRequests() {
    this.technicianService.technicianRequests().subscribe(data => {
      this.technicianRequest = data;
      console.log(this.technicianRequest);
      this.requestDisplayedColumns = ['unique_number', 'name', 'indicatorName', 'reference_number', 'status', 'taken_at', 'finished_at', 'time_taken'];
      this.requestColumnsToDisplay = this.requestDisplayedColumns.slice();
      this.requestDataSource = new MatTableDataSource<TechnicianRequest>(this.technicianRequest);
      this.requestSelection = new SelectionModel<TechnicianRequest>(true, []);
      this.requestDataSource.sort = this.sort.toArray()[1];
      this.requestDataSource.paginator = this.paginator.toArray()[1];
    });
  }

  busyTechnicians() {
    this.technicianService.busyTechnicians().subscribe(data => {
      this.busyTechnician = data;
      this.busyDisplayedColumns = ['unique_number','name', 'allIndicators', 'doneIndicators', 'takenIndicators', 'time_taken'];
      this.busyColumnsToDisplay = this.busyDisplayedColumns.slice();
      this.busyDataSource = new MatTableDataSource<BusyTechnician>(this.busyTechnician);
      this.busySelection = new SelectionModel<BusyTechnician>(true, []);
      this.busyDataSource.sort = this.sort.toArray()[2];
      this.busyDataSource.paginator = this.paginator.toArray()[2];
    });
  }


  getMachines() {
    this.machineService.getMachines().subscribe(data => {
      this.machines = data
    });

    return this.machines;
  }


  onChange() {
    switch (this.filter) {
      case 1:
        this.getTechnicians();
        break;
      case 2:
        // this.technicianRequests();
        break;
      case 3:
        this.busyTechnicians();
        break;

      default:
        break;
    }
    this.nameOrNumber = '';
  }

  filterTechnicians() {
    var filter = {};
    var fromDate;
    var toDate;
    if (this.fromDate != undefined) {
      fromDate = this.fromDate.format('DD/MM/YYYY');
    }

    if (this.toDate != undefined) {
      toDate = this.toDate.format('DD/MM/YYYY');
    }
    // if (this.fromDate != undefined && this.toDate != undefined) {
      filter = {
        nameOrNumber: this.nameOrNumber,
        filterType: this.filter,
        status: this.status != undefined ? this.status : -1,
        fromDate: fromDate,
        toDate: toDate,
        technician: this.technician,
        reference_number: this.reference_number
      };
    // } else {
    //   filter = {
    //     nameOrNumber: this.nameOrNumber,
    //     filterType: this.filter,
    //     status: this.status != undefined ? this.status : -1,
    //     technician: this.technician,
    //     reference_number: this.reference_number
    //   };
    // }

    this.technicianService.filterTechnicians(filter).subscribe(data => {
      switch (this.filter) {
        case 1:
          this.technicians = data;
          this.displayedColumns = ['unique_number', 'name', 'email', 'actions'];
          this.columnsToDisplay = this.displayedColumns.slice();
          this.dataSource = new MatTableDataSource<Technician>(this.technicians);
          this.selection = new SelectionModel<Technician>(true, []);
          this.dataSource.sort = this.sort.toArray()[0];
          this.dataSource.paginator = this.paginator.toArray()[0];
          break;
        case 2:
          this.technicianRequest = data;
          console.log(data);
          this.requestDisplayedColumns = ['unique_number', 'name', 'indicatorName', 'reference_number', 'status', 'taken_at', 'finished_at', 'time_taken'];
          this.requestColumnsToDisplay = this.requestDisplayedColumns.slice();
          this.requestDataSource = new MatTableDataSource<TechnicianRequest>(this.technicianRequest);
          this.requestSelection = new SelectionModel<TechnicianRequest>(true, []);
          this.requestDataSource.sort = this.sort.toArray()[1];
          this.requestDataSource.paginator = this.paginator.toArray()[1];
          break;
        case 3:
          this.busyTechnician = data;
          this.busyDisplayedColumns = ['unique_number','name', 'allIndicators', 'doneIndicators', 'takenIndicators', 'time_taken'];
          this.busyColumnsToDisplay = this.busyDisplayedColumns.slice();
          this.busyDataSource = new MatTableDataSource<BusyTechnician>(this.busyTechnician);
          this.busySelection = new SelectionModel<BusyTechnician>(true, []);
          this.busyDataSource.sort = this.sort.toArray()[2];
          this.busyDataSource.paginator = this.paginator.toArray()[2];
          break;
        default:
          break;
      }
    });
  }

  getTechniciansNames() {
    this.technicianService.getTechniciansNames().subscribe(data => {
      this.technicianNames = data;

    });
  }

  getActions() {
    this.actionService.moduleAction(14).subscribe(data => {
      if (data.watch_action == 1) {
        this.add = data.add_action;
        this.edit = data.edit_action;
        this.delete = data.delete_action;
      } else {
        this._location.back();
      }
    });
  }


  openDialog(id): void {
    if (id != 0) {
      this.technicianService.editTechnicians(id).subscribe(data1 => {
        console.log(data1);
        const dialogRef = this.dialog.open(TechnicianInsert, {
          width: '600px',
          data: { name: data1.name, phone: data1.phone, email: data1.email, machine_ids: data1.machine_ids, machines: this.machines }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            this.technicianService.updateTechnicians(result, id).subscribe(data => {
              this.getTechnicians();
            });


          }
        });
      });
    } else {
      console.log(this.machines);
      const dialogRef = this.dialog.open(TechnicianInsert, {
        width: '600px',
        data: { name: '', phone: '', machine_ids: [], machines: this.machines }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.technicianService.saveTechnicians(result).subscribe(data => {
            this.getTechnicians();
          });


        }
      });
    }
  }


  deleteModal(id, component): void {
    const dialogRef = this.dialog.open(ModalsComponent, {
      width: '250px',
      data: { id: id, component: component }
    });

    dialogRef.afterClosed().subscribe(result => {

      this.getTechnicians();
    });
  }

}

@Component({
  selector: 'technician-insert',
  templateUrl: 'technicianInsert.html',
})
export class TechnicianInsert {

  constructor(
    public dialogRef: MatDialogRef<TechnicianInsert>,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: Technician) { }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  submit(result) {
    if (result != undefined) {
      if (result.machine_ids.length > 0) {
        this.dialogRef.close(result);
      } else {
        this.openSnackBar('Изберете апарат', null);
      }
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
